import services from "../services";

const strict = true;

const getDefaultState = () => {
  return {
    invoiceNumber: null,
    invoiceDate: null,
    newInvoiceDocUploaded: false,
    newPrescriptionDocUploaded: false
  };
};

const state = getDefaultState();

const getters = {
  getInvoiceNumber: state => state.invoiceNumber,
  getInvoiceDate: state => state.invoiceDate,
  getInvoiceTotal: state => state.invoiceTotal,
  getNewInvoiceDocUploaded: state => state.newInvoiceDocUploaded,
  getNewPrescriptionDocUploaded: state => state.newPrescriptionDocUploaded
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  SET_INVOICE_NUMBER(state, num) {
    state.invoiceNumber = num;
  },
  SET_INVOICE_DATE(state, date) {
    state.invoiceDate = date;
  },
  SET_INVOICE_TOTAL(state, total) {
    state.invoiceTotal = total;
  },
  SET_NEW_INVOICE_DOC_UPLOADED(state, val) {
    state.newInvoiceDocUploaded = val;
  },
  SET_NEW_PRESCRIPTION_DOC_UPLOADED(state, val) {
    state.newPrescriptionDocUploaded = val;
  }
};

const actions = {
  async storeInvoiceNumber({ commit }, num) {
    await commit("SET_INVOICE_NUMBER", num);
  },
  async storeInvoiceDate({ commit }, date) {
    await commit("SET_INVOICE_DATE", date);
  },
  async storeInvoiceTotal({ commit }, total) {
    await commit("SET_INVOICE_TOTAL", total);
  },
  async storeNewInvoiceDocUploaded({ commit }, val) {
    await commit("SET_NEW_INVOICE_DOC_UPLOADED", val);
  },
  async storeNewPrescriptionDocUploaded({ commit }, val) {
    await commit("SET_NEW_PRESCRIPTION_DOC_UPLOADED", val);
  },
  async saveAllInvoiceData({ commit, getters, rootGetters }, appId) {
    try {
      let payload = {};
      let prescriptionDoc = null;
      let deletePreviousPrescriptionDoc = false;
      if (getters["getNewPrescriptionDocUploaded"]) {
        prescriptionDoc = rootGetters["billDocuments/getPrescriptionDoc"];
        deletePreviousPrescriptionDoc = true;
      }
      let invoiceDoc = null;
      let deletePreviousInvoiceDoc = false;
      if (getters["getNewInvoiceDocUploaded"]) {
        invoiceDoc = rootGetters["billDocuments/getInvoiceDoc"];
        deletePreviousInvoiceDoc = true;
      }
      let offId = rootGetters["hfManagement/officeId"];
      let obj = {
        invoiceNumber: getters["getInvoiceNumber"],
        invoiceDate: getters["getInvoiceDate"],
        invoiceTotal: getters["getInvoiceTotal"],
        prescriptionDocument: prescriptionDoc,
        invoiceDocument: invoiceDoc
      };
      payload.officeId = offId;
      payload.appointmentId = appId;
      payload.invoiceData = obj;
      let LOADING_DIALOG_TEXT = "dialogs.loading.contentLoadingDialogMsg";
      commit("loading/OPEN_LOADING_DIALOG", LOADING_DIALOG_TEXT, {
        root: true
      });
      if (deletePreviousPrescriptionDoc) {
        await services.billsService.removeBillPrescriptionDocument({
          officeId: offId,
          appointmentId: appId
        });
      }
      if (deletePreviousInvoiceDoc) {
        await services.billsService.removeBillInvoiceDocument({
          officeId: offId,
          appointmentId: appId
        });
      }
      await services.billsService.callSaveAllInvoiceData(payload);
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
    } catch (reason) {
      commit("loading/CLOSE_LOADING_DIALOG", null, {
        root: true
      });
      let errorDialogDetails = {
        ...reason
      };
      commit("error/SET_ERROR", errorDialogDetails, {
        root: true
      });
    }
  },
  async openSuccessDialogAfterSave({ commit, dispatch }, appId) {
    let success = {
      title: "appointments.details.invoiceData.success.title",
      message: "appointments.details.invoiceData.success.message",
      closeButtonLabel: "appointments.details.invoiceData.success.closeButton",
      closeButtonClb: () => {
        dispatch("bills/getProvidedServiceById", appId, { root: true });
      }
    };
    commit("success/openSuccessDialog", success, {
      root: true
    });
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
